import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _findLast from 'lodash/findLast';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Models
import mAsync from 'models/async';
import mDevice from 'models/device';
// Custom
import { deviceDataShape, asyncOperationDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const deviceStatusDetail = ({
  key, status, statusText, device,
}) => {
  const statusIcon = mAsync.statusIcon(status);
  return {
    key,
    icon: statusIcon.icon,
    iconColor: statusIcon.color,
    label: mDevice.installationDesc(device),
    value: <LocalizedMessage id={statusText} />,
  };
};

const ResourceAsyncStatusItem = ({ resource, devices, asyncOperation }) => {
  // Get async status information
  const { globalStatus, globalStatusDesc, devicesStatus } = mAsync.status(asyncOperation, resource, devices);
  const globalStatusIcon = mAsync.statusIcon(globalStatus);

  return (
    <InformationItem
      icon={globalStatusIcon.icon}
      iconColor={globalStatusIcon.color}
      label={<LocalizedMessage id="field.syncStatus" />}
      value={<LocalizedMessage id={globalStatusDesc} />}
      nestedItems={!_isEmpty(devices) ? _map(devicesStatus, deviceStatusDetail) : null}
    />
  );
};

ResourceAsyncStatusItem.propTypes = {
  resource: PropTypes.object.isRequired,
  idKey: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  devices: PropTypes.arrayOf(deviceDataShape).isRequired,
  asyncOperation: asyncOperationDataShape,
};

ResourceAsyncStatusItem.defaultProps = {
  asyncOperation: null,
};

const mapStateToProps = (state, ownProps) => ({
  asyncOperation: _findLast(state.asyncOperation.list, [ownProps.idKey, ownProps.resource.id]),
  devices: state.deviceData.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ResourceAsyncStatusItem);



// WEBPACK FOOTER //
// ./components/items/ResourceAsyncStatusItem.js